/*
 * cart-gel-guard.js — el gel automatico va AMARRADO al dispositivo.
 *
 * Motivo original (2026-07-27): un usuario subio el stepper del carrito hasta 242
 * geles automaticos. El gel es una suscripcion a $0 hoy que luego cobra $425
 * c/90 dias POR UNIDAD, asi que multiplicarlo es un problema real de cobro.
 *
 * Protocolo Firmeza (Mau, 2026-08-22): el gel automatico NO se puede borrar
 * solo. La unica forma de quitarlo es quitando el dispositivo: sin dispositivo
 * en el carrito, el gel se va solo (si se quedara, la clienta pagaria un gel
 * "gratis" sin protocolo y perderia el descuento del dispositivo).
 *
 * Que hace:
 *  1) Oculta el contador (+/-) Y la papelera SOLO en la linea del gel automatico
 *     del drawer de Rebuy. (v3) Tambien MATA los links de esa linea: llevaban al
 *     PDP del dummy, donde cualquiera podia re-agregar otro gel.
 *  2) Respaldo en JS (cada vez que el carrito cambia):
 *     a) si la cantidad del gel queda > 1 (carritos viejos, API, UI stale), la
 *        regresa a 1;
 *     b) si NO hay ningun dispositivo (skindion-rosa / skindion-negro) en el
 *        carrito, quita TODAS las lineas del gel automatico;
 *     c) (v3, 2026-08-26) DEDUPE: el gel solo puede existir en UNA linea. Dos
 *        ordenes reales (#142004, #141992) llegaron con 2 LINEAS del gel (mismo
 *        variant con propiedades distintas: carrito residual pre-cutover con la
 *        propiedad vieja "Renovación", o un add de otra superficie sin
 *        propiedades) = doble suscripcion de $425/90d. El clamp (a) es por linea
 *        y no lo veia: cada linea iba en qty 1. Se conserva la linea canonica
 *        del buybox (propiedad 'Gel automático'); el resto sale (qty 0).
 *
 * El unico camino para cambiar cantidades es el drawer de Rebuy: /cart redirige
 * al home. Aun asi el respaldo cubre carritos ya "envenenados".
 *
 * Nota: Rebuy renderiza su propia plantilla (el snippet rebuy-cart-template.liquid
 * del theme esta MUERTO), pero al <li> si le pone la clase product-<handle>.
 * Si cambia el HANDLE del gel automatico, actualizar GEL_HANDLE y GEL_VARIANT.
 */
(function (global) {
  'use strict';

  var GEL_HANDLE = 'gel-hidratante-200g-auto';
  var GEL_VARIANT = 49093433852139;
  var DEVICE_HANDLES = ['skindion-rosa', 'skindion-negro'];
  var DEVICE_VARIANTS = [44239767142635, 44267694719211];
  var MAX_QTY = 1;
  var CANON_PROP = 'Gel automático'; // propiedad que pone el buybox actual (js-main-product-protocolo.js)
  var BUILD = '2026-09-20-titulo';

  function isGel(it, variantId) {
    return !!it && (it.variant_id === variantId || (it.handle && it.handle === GEL_HANDLE));
  }

  function isDevice(it) {
    if (!it) return false;
    if (DEVICE_VARIANTS.indexOf(it.variant_id) !== -1) return true;
    return !!it.handle && DEVICE_HANDLES.indexOf(it.handle) !== -1;
  }

  /**
   * Logica pura (a): dadas las lineas del carrito, que cantidades hay que bajar a 1.
   * @param {Array<{variant_id:number, quantity:number, key:string, handle?:string}>} items
   * @returns {Array<{key:string, quantity:number}>}
   */
  function planClamp(items, variantId, maxQty) {
    variantId = variantId || GEL_VARIANT;
    maxQty = maxQty || MAX_QTY;
    var out = [];
    (items || []).forEach(function (it) {
      if (isGel(it, variantId) && it.quantity > maxQty) {
        out.push({ key: it.key, quantity: maxQty });
      }
    });
    return out;
  }

  /**
   * Logica pura (b): sin dispositivo en el carrito, el gel automatico sale (qty 0).
   * @returns {Array<{key:string, quantity:number}>}
   */
  function planOrphan(items, variantId) {
    variantId = variantId || GEL_VARIANT;
    var list = items || [];
    var hasDevice = list.some(isDevice);
    if (hasDevice) return [];
    var out = [];
    list.forEach(function (it) {
      if (isGel(it, variantId) && it.quantity > 0) out.push({ key: it.key, quantity: 0 });
    });
    return out;
  }

  /**
   * Logica pura (c): el gel automatico solo puede existir en UNA linea.
   * Shopify crea lineas separadas cuando el mismo variant entra con propiedades
   * distintas (carrito residual pre-cutover, adds de otras superficies) y el
   * clamp por linea no las ve. Se conserva la linea canonica del buybox
   * (propiedad 'Gel automático'); si ninguna la trae, la primera de la lista.
   * @returns {Array<{key:string, quantity:number}>} las lineas perdedoras, a 0.
   */
  function planDedupe(items, variantId) {
    variantId = variantId || GEL_VARIANT;
    var gels = (items || []).filter(function (it) { return isGel(it, variantId); });
    if (gels.length < 2) return [];
    var keeper = null;
    gels.forEach(function (it) {
      if (!keeper && it.properties && Object.prototype.hasOwnProperty.call(it.properties, CANON_PROP)) keeper = it;
    });
    if (!keeper) keeper = gels[0];
    var out = [];
    gels.forEach(function (it) {
      if (it !== keeper && it.quantity > 0) out.push({ key: it.key, quantity: 0 });
    });
    return out;
  }

  /**
   * Nombre visible del gel en el drawer: sin el sufijo interno "(automatico)" del
   * producto dummy (Mau, 2026-09-20). Solo cosmetico y SOLO en el drawer: el titulo
   * del producto no cambia (checkout, correos y Skio lo siguen mostrando).
   */
  var TITLE_SUFFIX = /\s*\(autom[aá]tico\)\s*$/i;
  function stripAutoSuffix(title) {
    return String(title == null ? '' : title).replace(TITLE_SUFFIX, '');
  }

  /** Plan completo: huerfanos primero (qty 0); si no, dedupe a una linea y clamp SOLO de las que sobreviven. */
  function planGuard(items, variantId, maxQty) {
    var orphan = planOrphan(items, variantId);
    if (orphan.length) return orphan;
    var dedupe = planDedupe(items, variantId);
    var fuera = {};
    dedupe.forEach(function (c) { fuera[c.key] = true; });
    var vivos = (items || []).filter(function (it) { return !fuera[it.key]; });
    return dedupe.concat(planClamp(vivos, variantId, maxQty));
  }

  // ---- Node (tests) ----
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      planClamp: planClamp,
      planOrphan: planOrphan,
      planDedupe: planDedupe,
      planGuard: planGuard,
      stripAutoSuffix: stripAutoSuffix,
      GEL_HANDLE: GEL_HANDLE,
      GEL_VARIANT: GEL_VARIANT,
      DEVICE_VARIANTS: DEVICE_VARIANTS,
      DEVICE_HANDLES: DEVICE_HANDLES,
      MAX_QTY: MAX_QTY,
      CANON_PROP: CANON_PROP,
      BUILD: BUILD
    };
    return;
  }

  // ---- Navegador ----
  var doc = global.document;
  if (!doc) return;
  global.__cartGelGuardBuild = BUILD; // QA: verificar en consola que Webrex no sirva una version stale

  // 1) Esconder el contador y la papelera en la linea del gel. Tambien el nombre
  //    y el separador de la propiedad de linea ("Gel automático :"), para que la
  //    linea del drawer EMPIECE con el valor ("Hoy $0 · luego $425…"; Mau,
  //    2026-08-22). Markup de Rebuy verificado: .rebuy-cart__flyout-item-property
  //    > -property-name + -property-separator + -property-value.
  function injectCss() {
    if (doc.getElementById('cart-gel-guard-css')) return;
    var sel = '.rebuy-cart__flyout-item.product-' + GEL_HANDLE;
    var css =
      sel + ' .rebuy-cart__flyout-item-quantity{display:none!important;}' +
      sel + ' .rebuy-cart__flyout-item-remove{display:none!important;}' +
      sel + ' .rebuy-cart__flyout-item-property-name,' +
      sel + ' .rebuy-cart__flyout-item-property-separator{display:none!important;}' +
      /* v3: sin links en la linea del gel — llevaban al PDP del dummy (re-agregable) */
      sel + ' a{pointer-events:none!important;cursor:default!important;}';
    var st = doc.createElement('style');
    st.id = 'cart-gel-guard-css';
    st.textContent = css;
    (doc.head || doc.documentElement).appendChild(st);
  }

  // 2) Respaldo: huerfanos fuera, cantidad a 1.
  var enVuelo = false;
  function guard() {
    if (enVuelo) return;
    enVuelo = true;
    global.fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cambios = planGuard(cart && cart.items);
        if (!cambios.length) return null;
        // Un cambio a la vez: /cart/change.js reescribe el carrito completo.
        return cambios.reduce(function (p, c) {
          return p.then(function () {
            return global.fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: c.key, quantity: c.quantity })
            });
          });
        }, global.Promise.resolve()).then(function () {
          // Refrescar el drawer para que muestre el carrito corregido.
          try {
            if (global.Rebuy && global.Rebuy.SmartCart && global.Rebuy.SmartCart.refresh) global.Rebuy.SmartCart.refresh();
            else doc.dispatchEvent(new global.CustomEvent('rebuy:cart.refresh'));
          } catch (e) {}
        });
      })
      .catch(function () { /* nunca romper el carrito por el respaldo */ })
      .then(function () { global.setTimeout(function () { enVuelo = false; }, 400); });
  }

  // 3) Titulo del gel sin "(automatico)". Rebuy lo pinta con v-html y re-renderiza
  //    el drawer; el observer lo vuelve a limpiar antes del paint. Aislado en
  //    try/catch: un fallo aqui nunca debe afectar al respaldo (guard).
  function cleanTitle() {
    try {
      var els = doc.querySelectorAll('.rebuy-cart__flyout-item.product-' + GEL_HANDLE + ' .rebuy-cart__flyout-item-product-title');
      for (var i = 0; i < els.length; i++) {
        var t = els[i].textContent, limpio = stripAutoSuffix(t);
        if (limpio !== t) els[i].textContent = limpio;
      }
    } catch (e) {}
  }

  function start() {
    injectCss();
    guard();
    try {
      cleanTitle();
      if (global.MutationObserver) {
        new global.MutationObserver(cleanTitle).observe(doc.documentElement, { childList: true, subtree: true, characterData: true });
      }
    } catch (e) {}
    ['rebuy:cart.change', 'rebuy:cart.add', 'rebuy:cart.ready', 'cart:updated']
      .forEach(function (ev) { doc.addEventListener(ev, function () { global.setTimeout(guard, 250); }, false); });
    // El drawer se puede abrir desde cualquier pagina; re-inyectar si Rebuy
    // reescribe el <head> o si su CSS carga despues.
    global.setInterval(injectCss, 2000);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
  else start();
})(typeof globalThis !== 'undefined' ? globalThis : this);
